const Footer = () => {
  return <footer className="my-2"></footer>;
};

export default Footer;
